import { type FunctionComponent, } from "react";
import type { BaseIconProps, } from "./types";


export const ArrowDown: FunctionComponent<BaseIconProps> = ({
	width,
	height,
	margin,
}) => {
	const style = () => Object.assign({}, width ? { width, } : {}, height ? { height, } : {}, margin ? { margin, }: {});

	return (
		<div className="icon arrow arrow-down" style={style()}>
			<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
				<path d="M6.99989 12.175L6.99989 1C6.99989 0.716666 7.09572 0.479166 7.28739 0.2875C7.47906 0.095833 7.71656 -3.44067e-07 7.99989 -3.31682e-07C8.28322 -3.19297e-07 8.52072 0.095833 8.71239 0.2875C8.90406 0.479166 8.99989 0.716666 8.99989 1L8.99989 12.175L13.8999 7.275C14.0999 7.075 14.3332 6.97917 14.5999 6.9875C14.8666 6.99583 15.0999 7.1 15.2999 7.3C15.4832 7.5 15.5791 7.73333 15.5874 8C15.5957 8.26667 15.4999 8.5 15.2999 8.7L8.69989 15.3C8.59989 15.4 8.49156 15.4708 8.37489 15.5125C8.25822 15.5542 8.13322 15.575 7.99989 15.575C7.86656 15.575 7.74156 15.5542 7.62489 15.5125C7.50822 15.4708 7.39989 15.4 7.29989 15.3L0.69989 8.7C0.516556 8.51667 0.424889 8.2875 0.424889 8.0125C0.424889 7.7375 0.516556 7.5 0.69989 7.3C0.89989 7.1 1.13739 7 1.41239 7C1.68739 7 1.92489 7.1 2.12489 7.3L6.99989 12.175Z" fill="white"/>
			</svg>
		</div>
	)
}
